module.exports = "iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAABR0lEQVR4Ad1RM0CtARi95rNt2zYz5tyabXPKWrJdS7Zt92wb47k2t4cf23dM+EueDF2o+31rj+FZ0wpcO0MB91r8ayRYknUPle270JWzFJvXkUCj0bQn2F9wA3MDG5EawAKNSkBgYCCioqLE4G0bSaoJTCrO403fatia0vnHPOW4uDgkJiaCyWTi5jkKXrWsUCQgZ+oguuEwHtUtx6lDZHm7WLJkCdytGfjZuhoLt3fKEqzNuYPGru2oS1uCVcuJimAWEWWxS/CtaC0mD+zByMp9EoKzxVfxaHADQu2ZIJMICmXt30HGdPUyvAvfiNF1+/hgGYJ3PStheIPKP5Yvy+QWFZ/aVuKJ+TYxUIFgzzaSQllL2ExEODHxu2E15i7tUgDLEMjn3bppKb+LL5nrMLGTn1drAl77/BVe+2zG6GoFkALBf/BwAGQ1FZ7x4fzSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./~/base64-loader!./client/components/FlagControl/png/16/KN.png
// module id = 1183
// module chunks = 0